export interface FSDocument extends Document {
    mozFullScreenElement: Element;
    mozCancelFullScreen: Promise<void>;
    msFullscreenElement: Element;
    msExitFullscreen: Promise<void>;
    webkitFullscreenElement: Element;
    webkitExitFullscreen: void;
}

export interface FSDocumentElement extends HTMLElement
{
    mozRequestFullScreen?: () => void;
    msRequestFullscreen?: () => void;
    webkitRequestFullscreen?: () => void;
}
